import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { exchangeRegistrationCode, tokenize } from "../../actions/auth";

export const registrationCode = (search = "") => new URLSearchParams(search).get("code");

export const safeRegistrationPath = (value) => {
  const path = String(value || "/dashboard");
  return path === "/dashboard" || path.startsWith("/dashboard?")
    ? path
    : "/dashboard";
};

export const completeRegistrationHandoff = async ({
  search = window.location.search,
  exchange,
  persistToken,
  history,
}) => {
  const code = registrationCode(search);
  if (!code) return false;

  const result = await exchange(code);
  if (!result?.success || !result?.token) return false;
  if (!await persistToken(result.token)) return false;

  history.replace(safeRegistrationPath(result.redirectPath));
  return true;
};

export const RegistrationHandoff = ({ exchangeRegistrationCode: exchange, tokenize: persistToken, history }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    completeRegistrationHandoff({ exchange, persistToken, history }).then((success) => {
      if (active && !success) setFailed(true);
    });
    return () => { active = false; };
  }, [exchange, persistToken, history]);

  return (
    <main className="container py-5" aria-live="polite">
      {failed ? (
        <div className="alert alert-danger" role="alert">
          This sign-in link is invalid or expired. Please return to the Feradel Start Free page and try again.
        </div>
      ) : (
        <p>Completing your secure Feradel sign-in&hellip;</p>
      )}
    </main>
  );
};

export default connect(null, { exchangeRegistrationCode, tokenize })(RegistrationHandoff);
